module.exports = __webpack_public_path__ + "static/media/bucket.545fd26b.svg";